export default {
  "content": "<path fill=\"#fbbc04\" d=\"M-304.294 276.787l-180.65 312.886-156.486-90.35 180.65-312.886z\"/><path d=\"M-123.6 499.3l-180.7-312.9c-24.9-43.2-80.2-58-123.4-33.1s-58 80.2-33.1 123.4l180.7 312.9c24.9 43.2 80.2 58 123.4 33.1s58-80.2 33.1-123.4z\" fill=\"#4285f4\"/><circle cx=\"-563.2\" cy=\"544.5\" r=\"90.3\" fill=\"#34a853\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "-669 126 573 524"
  }
};